// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    redirectURL: "https://dmy.hexoskin.com/",
    apiURL: "https://dapi.hexoskin.com/",
    dashDomain: "dmy.hexoskin.com",
    clientId: "T0IMLTqekAin4vbY2",
    secret: "jNqPzdZmUdxwhZqgxRZlRwl8GSszmm4hhkU7AU7V",
    flow: 'implicit',
    year: '2019',
    version: '2.1.1'
};
